export const BUTTON_TYPES = {
  PHONE: 'phone',
  LEAD_FORM: 'leadForm',
  PURCHASE: 'purchase',
  PREQUALIFY: 'prequalify',
  DELIVERY: 'delivery',
  CONTACT_SELLER: 'contactSeller',
};
